import { render, staticRenderFns } from "./revenuechannel.vue?vue&type=template&id=c4d51206"
import script from "./revenuechannel.vue?vue&type=script&lang=js"
export * from "./revenuechannel.vue?vue&type=script&lang=js"
import style0 from "./revenuechannel.vue?vue&type=style&index=0&id=c4d51206&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports